var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import classNames from 'classnames';
import { DivTag } from '../../Utils/AtomicTag';
import { defaultColProps } from './defaults';
export var prefix = function (pre, className) {
    if (!pre || !className) {
        return '';
    }
    if (typeof className === 'string') {
        return pre + "-" + className;
    }
    return classNames(className.filter(function (name) { return !!name; }).map(function (name) { return pre + "-" + name; }));
};
export var addPrefix = function (name) {
    return prefix('legao', name);
};
var Sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
var curry = function (fn) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return fn.bind.apply(fn, __spread([null], args));
}; };
var omitKeys = [];
var getValue = curry(function (obj, key) {
    omitKeys.push(key);
    return obj[key];
});
var omit = function (props, omitKeys) {
    var resetPros = {};
    for (var item in props) {
        if (omitKeys.indexOf(item) === -1) {
            resetPros[item] = props[item];
        }
    }
    return resetPros;
};
var Col = /** @class */ (function (_super) {
    __extends(Col, _super);
    function Col(props) {
        return _super.call(this, props) || this;
    }
    Col.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, span = _a.span, offset = _a.offset, rest = __rest(_a, ["className", "children", "span", "offset"]);
        var classes = {};
        var getPropValue = getValue(this.props);
        Sizes.forEach(function (size) {
            var colValue = getPropValue(size);
            classes[addPrefix("col-" + size + "-" + colValue)] = colValue >= 0;
        });
        classes[addPrefix("col-" + span)] = span > 0;
        classes[addPrefix("col-offset-" + offset)] = offset >= 0;
        var elementProps = omit(rest, omitKeys);
        return (React.createElement(DivTag, __assign({ name: Col.NAME }, elementProps, rest, { className: classNames(classes) }),
            React.createElement(DivTag, { className: "" + className }, children)));
    };
    Col.NAME = 'col';
    Col.defaultColProps = defaultColProps;
    return Col;
}(React.PureComponent));
export default Col;
